import React from "react";
import { Link } from "react-router-dom";

/**
 *
 * @param {children} children
 * @param {size} size
 * @param {link} link
 * @param {classe} classe
 * @param {rounded} rounded
 * @param {color} color
 * @returns
 */
const Button = (props) => {
  const { children, size, link = "/", classe, color } = props;

  let textSize, padding, backgound;

  //size
  if (size === "big") {
    textSize = "text-sm md:text-lg";
    padding = "py-4 px-6 md:px-8";
  } else if (size === "small") {
    textSize = "text-xs";
    padding = "py-2 px-3";
  } else {
    textSize = "text-base";
    padding = "py-5 px-6 md:py-5 lg:px-6";
  }

  if (color === "secondary") backgound = "bg-secondary";
  else if (color === "white") backgound = "bg-white text-secondary";
  else backgound = "bg-primary hover:bg-primary-dark";

  return (
    <Link
      to={link}
      className={`${classe} ${backgound} ${textSize} ${padding} animate mr-2 inline-block  rounded-lg px-5 py-4 text-xs font-medium text-white `}
    >
      {children}
    </Link>
  );
};

export default Button;
